module.exports = __webpack_public_path__ + "img/internet.73edf99b.jpg";